document.addEventListener("DOMContentLoaded", function () {

    // Sale products and their fixed discounts
    const saleProducts = {
        // MAX Plus Beach - £50 off
        "aquaplanet-max-plus-118-inflatable-sup-package-beach": 50,

        // MAX Glacier - £50 off
        "aquaplanet-max-10-6-inflatable-paddle-board-package-glacier-v2": 50,

        // PACE Coral - £30 off
        "aquaplanet-pace-10-6-inflatable-paddle-board-package-coral": 30,

        // ALLROUND TEN Spectre - £25 off
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-spectre": 25
    };

    // Apply a fixed £ discount to a price
    function applyFixedDiscount(priceText, discountAmount) {
        const price = parseFloat(
            priceText.replace(/[^0-9.]/g, "")
        );

        if (isNaN(price)) {
            return priceText;
        }

        const discountedPrice = price - discountAmount;

        return `£${discountedPrice.toFixed(2)}`;
    }

    // Get current URL path
    const urlParts = window.location.pathname.split("/");

    const isCollectionPage = urlParts.includes("collections");
    const isProductPage = urlParts.includes("products");

    // COLLECTION PAGES + HOMEPAGE
    if (
        isCollectionPage ||
        window.location.pathname === "/"
    ) {

        const productCards = document.querySelectorAll(
            ".cl-product-card-inner-container"
        );

        productCards.forEach((card) => {

            const productLink = card.querySelector(
                "a[href*='/products/']"
            );

            if (!productLink) {
                return;
            }

            const productHandle = productLink
                .getAttribute("href")
                .split("/products/")
                .pop()
                .split("?")[0]
                .split("#")[0];

            const discountAmount =
                saleProducts[productHandle];

            if (!discountAmount) {
                return;
            }

            const priceElement = card.querySelector(
                ".price-variation"
            );

            if (priceElement) {

                const currentPriceText =
                    priceElement.textContent;

                const discountedPrice =
                    applyFixedDiscount(
                        currentPriceText,
                        discountAmount
                    );

                priceElement.textContent =
                    `${discountedPrice} EXTRA £${discountAmount} OFF`;
            }
        });
    }

    // PRODUCT PAGES
    if (isProductPage) {

        const productHandle =
            urlParts[
                urlParts.indexOf("products") + 1
            ];

        const discountAmount =
            saleProducts[productHandle];

        if (!discountAmount) {
            return;
        }

        // Main product price
        const priceSnippet =
            document.querySelector(
                ".product-details-price-snippet .sale-price"
            );

        if (priceSnippet) {

            const currentPriceText =
                priceSnippet.textContent;

            const discountedPrice =
                applyFixedDiscount(
                    currentPriceText,
                    discountAmount
                );

            priceSnippet.textContent =
                `${discountedPrice} EXTRA £${discountAmount} OFF`;
        }

        // Add-to-cart price
        const formPrice =
            document.querySelector(
                ".product-form-price .price"
            );

        if (formPrice) {

            const currentPriceText =
                formPrice.textContent;

            const discountedPrice =
                applyFixedDiscount(
                    currentPriceText,
                    discountAmount
                );

            formPrice.textContent =
                `${discountedPrice} EXTRA £${discountAmount} OFF`;
        }
    }

});